<!-- Page title / breadcrumb -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <h4 class="page-title">{{ flow?.name }}</h4>
    </div>
  </div>
</div>

<!-- Editor (embedded React app — save/publish live inside the iframe) -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        @if (flow) {
          <iframe #flowFrame class="w-100 border-0" height="1000" [src]="urlEmbeded"></iframe>
        }
        <div class="mt-3">
          <button type="button" class="btn btn-light" routerLink="/flow">Voltar</button>
        </div>
      </div>
    </div>
  </div>
</div>
